import React, { useEffect, useState, useRef } from "react";
import { Select } from "antd";
import { list } from "../controllers/V1/users/usersController";

const SelectUsers = ({user_type = '', setAddEditData, defaultSelect = {}, mode = 'single', showSelectAll = false }) => {

const [OPTIONS, setOptions] = useState([defaultSelect] || []);
const [optionsLoading, setOptionsLoading] = useState(false);
const debounceTimeout = useRef(null);

const [ALLUSERSLIST, setAllUsersList] = useState([]);
const [selectedValues, setSelectedValues] = useState([]);

const isMultiSelect = mode === 'multiple';

// Load users by default on component mount
// useEffect(() => {
//     getUsersData('');
// }, []);
useEffect(() => {
    if (user_type) {
        setAllUsersList([]);
        setOptions([]);
        setSelectedValues([]);
        getUsersData('');
    }
}, [user_type]);

const getUsersData = async (searchText='') =>{
    try {
      setOptionsLoading(true);
      const option = {
        condition : {
            ...(user_type?{users_type : user_type}:null),
            ...(isNaN(searchText) === true && searchText !== ''?{
              $or : [
                { users_name : { $regex: searchText, $options: "i" } },
                { last_name : { $regex: searchText, $options: "i" } },
              ]
            }:{ 
              ...(searchText !== '' && !isNaN(searchText)?{
                $or : [
                  {users_mobile : parseInt(searchText)},
                  {pos_number : parseInt(searchText)},
                ]
              }:null)
            }) 
          // ...(search_by === ''?{ $text : { $search: searchString } }:null),
        },
        select : { users_type : true, users_name : true, last_name : true, users_mobile : true, users_email : true, store_name : true, area : true, bind_person_name : true, bind_person_mobile : true, commission_percentage : true, users_id : true, pos_serial_id : true, pos_number : true, availableArabianPoints : true, due_amount : true },
        sort : {_id : -1},
        limit : 0
      }
      const res = await list(option);
      if(res.status === true){
        setAllUsersList(res?.result || []);
      }
      setOptionsLoading(false);
    } catch (error) {
      setOptionsLoading(false);
    }
  }

const handleUserChange = (value) =>{
    try {
        if(isMultiSelect){
            // Filter out any special values (safety check)
            const filteredValues = value ? value.filter(v => v !== '__SELECT_ALL__') : [];
            setSelectedValues(filteredValues);
            const selectedUsers = filteredValues.map(v => JSON.parse(v));
            setAddEditData(selectedUsers);
        } else {
            // Handle single select (backward compatible)
            const userData = JSON.parse(value);
            setAddEditData((pre)=>({
                ...pre,
                bind_person_id : userData._id,
                bind_person_name : userData.users_name,
                bind_person_mobile : userData.users_mobile,
                userData : value
            }))
        }
    } catch (error) {
        console.log('error',error);
    }
}

const handleSelectAll = () => {
    if(isMultiSelect && OPTIONS.length > 0){
        const allValues = OPTIONS.map(opt => opt.value);
        handleUserChange(allValues);
    }
}

const handleDeselectAll = () => {
    if(isMultiSelect){
        handleUserChange([]);
        setSelectedValues([]);
    }
}

const handleSearch = (value) => {
    if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
        getUsersData(value);
    }, 500); 
};

useEffect(()=>{
    if(ALLUSERSLIST.length > 0){
      const transformedArray = ALLUSERSLIST.map(user => ({
        label: `${user.users_name} ${user.last_name} |  ${user.users_mobile}`,
        value: JSON.stringify(user) 
      }));
      
      setOptions(transformedArray);
      
      // Auto-select if single result and single select mode
      if(transformedArray.length === 1 && !isMultiSelect){
        setAddEditData((pre)=>({
            ...pre,
            bind_person_id : ALLUSERSLIST[0]._id,
            bind_person_name : ALLUSERSLIST[0].users_name,
            bind_person_mobile : ALLUSERSLIST[0].users_mobile
        }))
      }
    }
  },[ALLUSERSLIST, isMultiSelect]);

  const handleClear = async () => {
    setOptions([]);
    setSelectedValues([]);
    if(isMultiSelect){
        setAddEditData((pre)=>({
            ...pre,
            selectedUsers: [],
            userData: []
        }));
    } else {
        setAddEditData((pre)=>({
            ...pre,
            bind_person_id : '',
            bind_person_name : '',
            bind_person_mobile : '',
            userData : ''
        }));
    }
    setAllUsersList([]);
  }

  const handleDropdownVisibleChange = (open) => {
    if(open && ALLUSERSLIST.length === 0){
        getUsersData('');
    }
  }

  return (
    <Select
        className="form-control"
        onSearch={handleSearch}
        onChange={handleUserChange}
        showSearch={true}
        defaultOpen={false}
        autoClearSearchValue={false}
        placeholder={isMultiSelect ? "Select Users" : (OPTIONS?.[0]?.label || "Search to Select")}
        notFoundContent={null}
        loading={optionsLoading}
        defaultActiveFirstOption={true}
        options={OPTIONS}
        mode={isMultiSelect ? 'multiple' : undefined}
        value={isMultiSelect ? selectedValues : undefined}
        maxTagCount={isMultiSelect ? 3 : undefined}
        allowClear
        onClear={handleClear}
        onDropdownVisibleChange={handleDropdownVisibleChange}
        dropdownStyle={{ zIndex: 9999999 }}
        dropdownRender={(menu) => (
            <>
                {showSelectAll && isMultiSelect && OPTIONS.length > 1 && (
                    <div style={{ padding: '8px', borderBottom: '1px solid #f0f0f0' }}>
                        <a 
                            onClick={handleSelectAll}
                            style={{ marginRight: '8px', cursor: 'pointer' }}
                        >
                            Select All
                        </a>
                        {selectedValues.length > 0 && (
                            <a 
                                onClick={handleDeselectAll}
                                style={{ cursor: 'pointer', color: '#ff4d4f' }}
                            >
                                Deselect All
                            </a>
                        )}
                    </div>
                )}
                {menu}
            </>
        )}
    />
  );
};

export default SelectUsers;
